<app-error-page
  title="403 Forbidden"
  primaryText="You do not have permission to access this page."
></app-error-page>
<div class="button--container">
  <app-button
    label="Go to Dashboard"
    buttonId="dashboard-btn"
    (buttonClicked)="goToDashboard()"
  ></app-button>
</div>
